export const isWeekday = date => {
	const day = date.day();
	return day !== 0 && day !== 6;
};
